import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cruiseControl"
const CruiseControlIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.901 7.902 2 6.589 8.214 3 6.901 7.902Zm4.052 10.666c-.106-.184-.182-.404-.261-.704-.078-.299-.158-.68-.239-1.13a36.36 36.36 0 0 1-.184-1.119c-.035-.228-.06-.406-.075-.51l-.331-2.425 1.934 1.499a40.238 40.238 0 0 1 1.408 1.146c.646.554 1.028.924 1.212 1.243a1.999 1.999 0 1 1-3.464 2Zm8.218.501a6.994 6.994 0 0 0 .498-2.599c0-.919-.177-1.796-.498-2.599l-1.239.715a.999.999 0 1 1-1-1.732l1.237-.714a6.992 6.992 0 0 0-4.5-2.599v1.429a1 1 0 1 1-2 0V9.541a6.987 6.987 0 0 0-4.5 2.599l1.237.714a1 1 0 0 1-1 1.732l-1.238-.715a6.967 6.967 0 0 0-.499 2.599c0 .918.177 1.795.499 2.599l1.238-.715a1 1 0 1 1 1 1.732l-1.484.857-1.5.865a8.959 8.959 0 0 1-1.753-5.338 9 9 0 0 1 9-9 9 9 0 0 1 9 9 8.953 8.953 0 0 1-1.754 5.338l-1.498-.865-1.485-.857a1 1 0 0 1 1-1.732l1.239.715Z"
      />
    </svg>
  )
}
export default CruiseControlIcon
